import { AcademicCapIcon, BeakerIcon, BookOpenIcon, BriefcaseIcon, ChatBubbleLeftRightIcon, ComputerDesktopIcon, FilmIcon, GlobeAltIcon, MusicalNoteIcon, PaintBrushIcon, PresentationChartBarIcon, PuzzlePieceIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { getCampusColor } from '@/app/types/colors';
import { meetingTypeLabel } from '@/app/lib/meetingTypes';

export function CampusChips({ campuses }: { campuses: string[] }) {
  return <span className="flex flex-wrap gap-1.5">{[...new Set(campuses.filter(Boolean))].map(campus => <span key={campus} className={`inline-flex rounded-control px-2 py-1 text-xs font-medium ${getCampusColor(campus, 'badge')}`}>{campus}</span>)}</span>;
}
export function meetingTypeIcon(value: string) {
  if (/online|internet/i.test(value)) return ComputerDesktopIcon;
  if (/^lab|clinic|rsch/i.test(value)) return BeakerIcon;
  if (/lec|demon/i.test(value)) return PresentationChartBarIcon;
  if (/recit|lang/i.test(value)) return ChatBubbleLeftRightIcon;
  if (/sem|workshop|wkp/i.test(value)) return UserGroupIcon;
  if (/studio/i.test(value)) return PaintBrushIcon;
  if (/mus/i.test(value)) return MusicalNoteIcon;
  if (/film/i.test(value)) return FilmIcon;
  if (/exchange|abroad|fld/i.test(value)) return GlobeAltIcon;
  if (/intern|pract/i.test(value)) return BriefcaseIcon;
  if (/proj|phy ed/i.test(value)) return PuzzlePieceIcon;
  if (/graduate|honors|registration/i.test(value)) return AcademicCapIcon;
  return BookOpenIcon;
}
export function MeetingTypeLabels({ values }: { values: string[] }) {
  return <span className="flex flex-wrap gap-x-3 gap-y-1.5">{[...new Set(values)].map(value => { const Icon=meetingTypeIcon(value); return <span key={value} className="inline-flex items-center gap-1.5 text-xs text-content-muted" title={value}><Icon aria-hidden="true" className="h-4 w-4 shrink-0" />{meetingTypeLabel(value) || value}</span>; })}</span>;
}
